const versionTargets = document.querySelectorAll("[data-app-version]");

if (versionTargets.length > 0) {
  void loadVersion().then((version) => {
    if (!version) return;
    const normalized = version.replace(/^v/i, "");
    const label = `Version: v${normalized}`;
    for (const element of versionTargets) {
      element.textContent = label;
    }
  });
}

async function loadVersion() {
  try {
    const response = await fetch("./package.json", { cache: "no-cache" });
    if (!response.ok) return null;

    const payload = await response.json();
    const version = typeof payload?.version === "string" ? payload.version.trim() : "";
    return version || null;
  } catch {
    return null;
  }
}
